import type { StorageProvider } from '@cli-types/next-adapter/init.js'

export const DATABASE_PROVIDERS = ['vercel', 'railway', 'manual'] as const
export const STORAGE_PROVIDERS = ['vercel-blob', 'railway-bucket', 'r2', 'local'] as const
export const DEPLOY_PROVIDERS = ['vercel', 'railway', 'none'] as const
export const RAILWAY_BUCKET_REGIONS = ['sjc', 'iad', 'ams', 'sin'] as const
export const STORAGE_INTEGRATIONS = new Set<StorageProvider>([
  'vercel-blob',
  'railway-bucket',
  'r2'
])
